export default "__VITE_ASSET__4bbfd51f__"